/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonatsauswertungLayoutDto } from '../../models/monatsauswertung-layout-dto';

export interface GetMonatsauswertungLayoutById$Json$Params {
  id: string;
}

export function getMonatsauswertungLayoutById$Json(http: HttpClient, rootUrl: string, params: GetMonatsauswertungLayoutById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MonatsauswertungLayoutDto>> {
  const rb = new RequestBuilder(rootUrl, getMonatsauswertungLayoutById$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonatsauswertungLayoutDto>;
    })
  );
}

getMonatsauswertungLayoutById$Json.PATH = '/v1/monatsauswertungen/layouts/{id}';
